<template>
  <div>
    <el-form ref="form"
             v-if="canUpdate()"
             :model="form"
             :rules="rules">
      <el-form-item prop="provision">
        <el-autocomplete
          class="inline-input full"
          v-model="form.provision"
          :fetch-suggestions="querySearch"
          placeholder="Seleccione el deducible"
          @select="handleSelect"
        >
          <template slot-scope="props">
            <div class="ft-left">{{ props.item.provision.name }}  </div>
            <span class="ft-right">{{ props.item.percentage }} %</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
          <ul>
            <li v-for="item in error.errors">{{ item[0] }}</li>
          </ul>
          </p>
        </div>
      </div>
    </el-form>
    <app-table
      @change-pagination="onChangePagination"
      :total="total"
      :disable_search="true">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="provision.name"
          label="Deducible">
        </el-table-column>
        <el-table-column
          prop="percentage"
          label="Porcentaje">
        </el-table-column>
        <el-table-column
          v-if="canUpdate()"
          :width ="100"
          label="Acciones">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>
  </div>
</template>
<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  export default {
    extends: BaseCrud,
    name: 'company-list',
    props: ['payroll_id', 'company_id'],
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + `/provisionsByPayroll/${this.payroll_id}`,
        form: {
        },
        state1: '',
        provisions: [],
        activeName: 'first',
        basePermission: 'payrolls',
        rules: {
          provision_id: [{ required: true, message: 'El deducible es requerido', trigger: 'blur' }],
          percentage: [{required: true, message: 'age is required'},
            {type: 'number', message: 'age must be a number'}]
        }
      }
    },
    watch: {
      payroll_id: function () {
        this.loadAll()
      }
    },
    methods: {
      querySearch (queryString, cb) {
        var links = this.provisions
        var results = queryString ? links.filter(this.createFilter(queryString)) : links
        cb(results)
      },
      createFilter (queryString) {
        return (item) => {
          return (item.provision.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll () {
        this.baseUrl = baseApi + `/provisionsByPayroll/${this.payroll_id}`
        this.refreshData()
        this.$http.get(baseApi + '/provisionsbycompany/' + this.company_id)
          .then(
            (res) => {
              this.provisions = res.body
            }
          )
      },
      handleSelect (item) {
        this.form.provision = item.provision.name
        this.form.provision_by_company_id = item.id
        this.save()
      },
      _mounted () {
        this.loadAll()
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar ' + model.provision.name
      },
      handleDelete (index, row) {
        this.$confirm(this._getDeleteTitle(row), 'Advertencia', {
          confirmButtonText: 'Si',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$http.delete(baseApi + '/provisionsByPayroll/' + row.id + '/' + this.payroll_id)
            .then(
              () => {
                this.$message({
                  type: 'success',
                  message: 'Eliminado correctamente.'
                })
                this.tableData = this.tableData.filter((item) => {
                  return item.id !== row.id
                })
                this.loading = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loading = false
              }
            )
        })
      }
    }
  }
</script>
<style>

  .full{
    width: 100%;
  }
  .ft-left{
    float: left;
    height: 20px;
  }

  .ft-right{
    float: right;
  }
  .text-center{
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/payrolls/ProvisionsTable.vue